export default "__VITE_ASSET__9MyTqAOy__"